import api from './api';

const cashRegisterService = {
  /**
   * Obtener todas las cajas registradoras
   */
  getAll: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.punto_venta_id) {
        params.append('punto_venta_id', filters.punto_venta_id);
      }
      
      if (filters.is_active !== undefined) {
        params.append('is_active', filters.is_active);
      }

      const response = await api.get(`/cash-registers?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching cash registers:", error);
      throw error;
    }
  },

  /**
   * Obtener una caja específica
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/cash-registers/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching cash register:", error);
      throw error;
    }
  },

  /**
   * Crear una nueva caja registradora
   */
  create: async (data) => {
    try {
      const response = await api.post('/cash-registers', data);
      return response.data;
    } catch (error) {
      console.error("Error creating cash register:", error);
      throw error;
    }
  },

  /**
   * Actualizar una caja registradora
   */
  update: async (id, data) => {
    try {
      const response = await api.put(`/cash-registers/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating cash register:", error);
      throw error;
    }
  },

  /**
   * Eliminar una caja registradora
   */
  delete: async (id) => {
    try {
      const response = await api.delete(`/cash-registers/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting cash register:", error);
      throw error;
    }
  },
};

export default cashRegisterService;